/* eslint-disable */
export default {
  downloadSuccess: '로그가 다운로드되었습니다.',
  downloadFail: '오류 로그 다운로드에 실패했습니다. 다시 시도하세요.',
} as const;

// @key: @#@"downloadSuccess"@#@ @source: @#@"Log downloaded."@#@
// @key: @#@"downloadFail"@#@ @source: @#@"Error log download failed. Please try again."@#@
